import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DropDirective } from './drop.directive'
import { TwoDigitDecimalNumberDirective } from './two-digit-decimal-number.directive'
import { TemplateRefDirective } from './template-ref.directive'
import { DndDirective } from './dnd.directive'
import { ResetInputScrollDirective } from './reset-input-scroll.directive'
import { PasteValidatorDirective } from './paste-validator.directive'
import { NumericOnlyDirective } from './numeric-only.directive'

@NgModule({
  declarations: [
    DropDirective,
    TwoDigitDecimalNumberDirective,
    TemplateRefDirective,
    DndDirective,
    ResetInputScrollDirective,
    PasteValidatorDirective,
    NumericOnlyDirective,
  ],
  imports: [CommonModule],
  exports: [
    DropDirective,
    TwoDigitDecimalNumberDirective,
    TemplateRefDirective,
    DndDirective,
    ResetInputScrollDirective,
    PasteValidatorDirective,
    NumericOnlyDirective,
  ],
})
export class DirectiveModule {}
